/**
 * Represents the counts when callers are updated via import.
 */
export class ImportCallerCounts {
   public callersAdded: number;
   public callersUpdate: number;
   public callersDeleted: number;
   public originalCallersCount: number;
}